import { IUserGroup } from './groups';

export enum ReactionType {
  Heart = 'heart',
}

export type Upload = {
  id: string;
  path: string;
  name: string;
  type: string | null;
  store: string;
};

export type MessageImage = {
  id: string;
  messageId: string;
  uploadId: string;
  upload: Upload;
  sort: number;
};

export type Reaction = {
  id: string;
  messageId: string;
  userId: string;
  type: ReactionType;
  createdAt: string;
};

export type Message = {
  id: string;
  text: string | null;
  chatId: string;
  author: string;
  authorAvatar: string | null;
  communityName: string | null;
  images: MessageImage[];
  reactions: Reaction[];
  isRead: boolean;
  isLiked: boolean;
  createdAt: string;
};

export type PaginatedMessages = {
  data: Message[];
  nextCursor: string | null;
};

export type ChatLastMessage = {
  text: string | null;
  createdAt: string;
};

export type Chat = {
  id: string;
  title: string;
  systemName: string;
  type: 'personal' | 'public';
  sort: number;
  unreadCount: number;
  lastMessage: ChatLastMessage | null;
  usersAmount: number | null;
  uploadId: string | null;
  upload: Upload | null;
  chatGroups: ChatGroup[];
  createdAt: string;
  updatedAt: string;
};

export type ChatGroup = {
  id: string;
  title: string;
  systemName: string;
  sort: number;
  chats: Chat[];
  createdAt: string;
  updatedAt: string;
};

export type AdminChat = {
  id: string;
  title: string;
  systemName: string;
  type: 'personal' | 'public';
  userId: string | null;
  sort: number;
  uploadId: string | null;
  upload: Upload | null;
  userGroups: IUserGroup[];
  chatGroups: ChatGroup[];
  createdAt: string;
  updatedAt: string;
};

export type ChatTemplate = {
  id: string;
  systemName: string;
  title: string;
  sort: number;
  uploadId: string | null;
  upload: Upload | null;
  chatGroupId: string | null;
  chatGroup: ChatGroup | null;
  createdAt: string;
  updatedAt: string;
};
